module.exports = __webpack_public_path__ + "static/media/01alpen_n.ed9cff42.svg";